export const URLS = {
    API_URL : "https://api-dev.funcomp.com/api",
    APP_URL : "https://dev.funcomp.com/"
  };
  